import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=68a7ccbc&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=68a7ccbc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7ccbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68a7ccbc')) {
      api.createRecord('68a7ccbc', component.options)
    } else {
      api.reload('68a7ccbc', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=68a7ccbc&scoped=true", function () {
      api.rerender('68a7ccbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/components/Banner.vue"
export default component.exports